import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import Select from 'react-select';
import { Field } from '../../../ui/Field';
import UpdatePage from '../../../composents/UpdatePage';

const title = 'Entities';
const headers = {
	icon: 'feather icon-edit',
	title: title,
	description: 'update of entity',
	breadcrumbs: [
		{
			title: title,
			link: '/hydrodrip/hd_entities',
		},
	],
};

export default function EditHdEntity() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[city, setCity] = useState(),
		[cities, setCities] = useState([]),
		[country, setCountry] = useState(),
		[countries, setContries] = useState([]),
		[fail, setFail] = useState(false),
		[loading, setLoading] = useState(true),
		[data, setData] = useState({}),
		{ id } = useParams();

	async function onGet() {
		setLoading(true);
		let res = await resources.entity
			.readOne(id)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			setData(res.data);
		} else if (res.status === 403) {
			setFail(true);
		}

		let cus = await resources.country
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		if (cus.status === 200) {
			let a = [];
			cus.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setContries(a);
		}

		let cit = await resources.city
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cit.status === 200) {
			let a = [];
			cit.data.docs.forEach((el) => {
				if (res.data.city === el.id) {
					setCity({
						value: el.id,
						label: el.name,
						country: el?.country?.id,
					});
					setCountry({
						value: el?.country?.id,
						label: el?.country?.name,
					});
				}
				a.push({
					value: el.id,
					label: el.name,
					country: el?.country?.id,
				});
			});
			setCities(a);
		}
		setLoading(false);
	}

	useEffect(() => {
		onGet();
	}, [id]);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onUpdate(e) {
		e.preventDefault();
		setLoader(true);
		setErrors({});
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));

		if (city) {
			object.city = city.value;
		}

		let res = await resources.entity
			.update(id, object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/hydrodrip/hd_entities');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	const filterCity = () => {
		let all_cities = [];
		if (country) {
			all_cities = cities.filter((e) => e.country === country.value);
		}
		return all_cities;
	};

	return (
		<UpdatePage
			show_error={errors['not_autorized']}
			loading={loading}
			fail={fail}
			headers={headers}
		>
			<form onSubmit={onUpdate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Country name{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => {
											setCountry(e);
											setCity(null);
										}}
										options={countries}
										value={country}
										required
										isSearchable
										isClearable
									/>
								</div>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										City name{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setCity(e)}
										options={filterCity()}
										value={city}
										isSearchable
										isClearable
										required
										className={
											errors['city'] ? ' is-invalid' : ''
										}
									/>
									{errors['city'] && (
										<div className="invalid-feedback">
											{errors['city']}
										</div>
									)}
								</div>

								<Field
									name="name"
									className="mb-3"
									error={errors['name']}
									required
									defaultValue={data?.name}
								>
									Entity name
								</Field>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
									defaultValue={data?.description}
								>
									Description
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary "
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</UpdatePage>
	);
}
